import { GlobalProxy } from "@/proxy/global-proxy";
import { MutationPayload } from "vuex";
import { UPSERT_VALIDATED_ANSWER } from "../mutation.type";
import router from "@/router/index";

export const answerChageSubscriber = async (
  mutation: MutationPayload,
  state: any
) => {
  if (mutation.type === UPSERT_VALIDATED_ANSWER) {
    GlobalProxy.$data.pushValidatedAnswerCache(
      router.app.$route.params.sample_id,
      state.questionnaire.validatedAnswerCache
    );
  }
};
